import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCanEditContent } from '@/features/admin-content/use-current-user';
import { BankImport } from '@/features/staff-bank/BankImport';

export const Route = createFileRoute('/admin/bank/import')({
  component: BankImportPage,
});

function BankImportPage() {
  const allowed = useCanEditContent();
  if (!allowed) {
    return (
      <StaffOnly
        title="You cannot add content"
        description="Ask an admin to switch on Content editor for you."
      />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Import questions"
        description="Check a file, then add its questions as Drafts."
      />
      <BankImport />
    </div>
  );
}
